import Notification from '@utils/notification';
import Track from '@utils/track';

const scrollToRequiredDiv = function (divId) {
  if (typeof document === 'undefined') return;

  const scrollToDiv = new URL(location.href).searchParams.has(divId);
  const elem = document.getElementById(divId);
  if (elem && scrollToDiv) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }
};

const copySectionLink = async function (page, sectionId) {
  const newUrl = new URL(page.url);
  newUrl?.searchParams?.set('section-id', sectionId);
  navigator.clipboard
    .writeText(newUrl)
    .then(function () {
      Notification.send({
        text: 'Section Link copied!',
      });
    })
    .catch(function () {
      Notification.send({
        text: 'Section Link could not be copied!',
      });
    });
};

const copyCollectionLink = async function (page, collectionId, currentUser, profileUserId) {
  const newUrl = new URL(page.url);
  newUrl?.searchParams?.set('collection-id', collectionId);
  navigator.clipboard
    .writeText(newUrl)
    .then(function () {
      Notification.send({
        text: 'Collection Link copied!',
      });
      Track.profileShareCollection({ currentUser, profileUserId, collectionId });
    })
    .catch(function () {
      Notification.send({
        text: 'Collection Link could not be copied!',
      });
    });
};

const scrollToRequiredDivById = function (divId, options = { behavior: 'smooth' }) {
  if (typeof document === 'undefined') return;

  const elem = document.getElementById(divId);
  if (elem) {
    elem.scrollIntoView(options);
  }
};

const loadRequestedSection = async function (page, prefix) {
  const requestedSectionId = page.url.searchParams.get('section-id');
  if (requestedSectionId != null) {
    setTimeout(scrollToRequiredDivById, 100, `${prefix}${requestedSectionId}`);
  }
};

export default {
  scrollToRequiredDiv,
  copySectionLink,
  copyCollectionLink,
  loadRequestedSection,
  scrollToRequiredDivById,
};
